import gql from 'graphql-tag';

import { baseUserSettingsFragment } from '../fragments/baseUserSettings';

export default gql`
  query initialInventorySettings($moduleName: String!, $viewName: String) {
    defaultColumns(moduleName: $moduleName) {
      header
      binding
      isReadOnly
      visible
      wordWrap
      size
      isContentHtml
      format
      aggregate
      align
    }
    defaultSorting(moduleName: $moduleName) {
      sorting {
        property
        ascending
      }
    }
    defaultGroupPanels(moduleName: $moduleName) {
      groups
    }
    userSettings(moduleName: $moduleName, viewName: $viewName) {
      ...baseUserSettings
      state
      month
      months {
        id
        value
        text
      }
      states {
        id
        value
        text
      }
    }
  }
  ${baseUserSettingsFragment}
`;
